// @core/api/endpoints/fiscalization/resolve_fiscal_context.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolveFiscalContextRequest,
  ResolveFiscalContextResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Resolve fiscal context
 * Resolves the effective fiscal policy for a scope entity by merging the policy hierarchy. Returns merged policy and available fiscal points.
 */
export async function ResolveFiscalContext(
  data: ResolveFiscalContextRequest,
  options?: RequestOptions
): Promise<ResolveFiscalContextResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/fiscal/resolve-context`;
  const requestOptions = options;
  return client.post<ResolveFiscalContextResponse>(requestPath, data, requestOptions);
}
